import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, message, Image, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { get, post, setMerchantToken, setMerchantApps, getMerchantToken } from '../../utils/merchantApi';
import CryptoJS from 'crypto-js';

const MerchantLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    const token = getMerchantToken();
    if (token) {
      navigate('/merchant');
    }
  }, [navigate]);

  const encryptPassword = (password) => {
    return CryptoJS.SHA256(password).toString();
  };

  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const response = await post('/app/auth/login', {
        loginType: 'password',
        phone: values.phone,
        password: encryptPassword(values.password)
      });

      if (response.data?.token) {
        setMerchantToken(response.data.token);
        
        const appsResponse = await get('/merchant/apps');
        if (appsResponse.data?.length > 0) {
          setMerchantApps(appsResponse.data);
          if (appsResponse.data.length === 1) {
            localStorage.setItem('currentAppId', appsResponse.data[0].app_id);
          }
        } else {
          message.error('您尚未绑定商户应用');
          return;
        }

        message.success('登录成功');
        navigate('/merchant');
      }
    } catch (error) {
      console.error('登录失败:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <Card
        style={{
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          borderRadius: '12px'
        }}
        bodyStyle={{ padding: '40px 32px' }}
      >
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{ 
            fontSize: '28px', 
            fontWeight: '600', 
            color: '#262626',
            marginBottom: '8px'
          }}>
            商户管理后台
          </h1>
          <p style={{ color: '#8c8c8c', fontSize: '14px' }}>
            商户登录
          </p>
        </div>

        <Form
          form={form}
          name="merchantLogin"
          onFinish={handleLogin}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="phone"
            rules={[
              { required: true, message: '请输入手机号' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="手机号"
              style={{ borderRadius: '8px' }}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6位' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
              style={{ borderRadius: '8px' }}
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              block
              style={{ 
                borderRadius: '8px',
                height: '44px',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              登录
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'center' }}>
            <Button type="link" onClick={() => navigate('/login')}>
              返回管理员登录
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default MerchantLogin;
